module.exports = __webpack_public_path__ + "static/media/oval1.a9c3fc5e.svg";